
import Previewer from 'vux/src/components/previewer/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import wxConfig from '@/assets/js/wx_config'

export default {
name: "dynamicShare_in",
directives: {
TransferDom
},
components:{
Previewer,
},
data(){
return{
dynamicId:this.$route.query.dynamicId,
dynamic:new Array(),
dynamicFlag:false,
titleFlag:true,
swImgUrlList:new Array(),
imgHeight:0,
previewImgUrl:new Array(),
playerOptions : {
playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
autoplay: true, //如果true,浏览器准备好时开始回放。
muted: false, // 默认情况下将会消除任何音频。
loop: false, // 导致视频一结束就重新开始。
preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
language: 'zh-CN',
aspectRatio: '4:3', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
sources: [{
type: "video/mp4",//这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
src: "" 
}],
poster: "", //你的封面地址

notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
controlBar: {
timeDivider: true,
durationDisplay: true,
remainingTimeDisplay: false,
fullscreenToggle: true  
}
}
}
},
created(){
this.getDynamicInfo();
},
mounted() {
this.$store.commit('UPDATE_HEAD',false);
this.$store.commit('UPDATE_FOOTER',false);
this.$store.commit('UPDATE_PAGE_TITLE','动态分享');
document.title = '动态分享'
},
methods:{
getDynamicInfo(){
let self = this
this.baseAjax({
url:'/dynamic/getDynamicInfo',
showLoading:true,
type:'post',
data:{
"dynamicId":self.dynamicId
},
success:function (data) {
console.log(data)
if(data.resultCode === 0){
self.dynamic = data.dynamic;
if(data.dynamic.resourceType === 0){
self.initPreviewImgUrl()
}else{
self.initVideo()
}
self.dynamicFlag = true;
if(wxConfig.isWeiXin()){
let title = data.dynamic.user.nickName + "与您分享美好时刻"
let desc = "快来看看" + data.dynamic.user.nickName + "记录的点滴时光吧"
if(data.dynamic.description !== undefined && data.dynamic.description !== ''){
desc = data.dynamic.description
}
let linkUrl = "http://mobile.mianhuain.com/#/homePortal/dynamicShare_in?dynamicId=" + data.dynamic.dynamicId
let imgUrl = data.dynamic.resources[0].thumbnailUrl100;
wxConfig.wxConfigBuild_in(title,desc,linkUrl,imgUrl);
}
}else{





self.$vux.toast.show({
text: data.message,
type:'text',
position:'middle',
width:'60%',
})
}

}
});
},
initPreviewImgUrl(){
let resources = this.dynamic.resources
resources.forEach((item,index) =>{
let imgUrl = item.thumbnailHDUrl
this.previewImgUrl.push({src:imgUrl,w:item.width,h:item.height,index:index})
})
},
initVideo(){
let videoPoster = this.dynamic.resources[0].thumbnailHDUrl;
this.playerOptions.poster = videoPoster
this.playerOptions.sources[0].src = this.dynamic.resources[0].url
console.log(this.playerOptions.sources[0].src)
},
previewImage(e){
if (e.target.nodeName == 'IMG') {
console.log(e.target.currentSrc)
let imgUrl = e.target.currentSrc;
let previewUrl = this.previewImgUrl.filter(item => item.src === imgUrl)[0]
this.$refs.previewer.show(previewUrl.index);
}
},
descClick(){
this.titleFlag = !this.titleFlag
},
parCatyUpdateHeight(){
let diffHeight = window.screen.width;
this.$nextTick(() => {
this.$refs.cateSwiper.xheight =  diffHeight + 'px'
})
}
}
}



// WEBPACK FOOTER //
// ./src/components/share/dynamicShare_in.vue